<template>
  <div>
    <img
      style="width: 100vw; padding: 20px; box-sizing: border-box;"
      src="../assets/img/toplogo.png"
    />
    <el-menu
      :default-active="'/'"
      mode="horizontal"
      :router="true"
      style="font-size: 18px;"
      active-text-color="#98E13B"
    >
      <el-menu-item index="/">U宠物定位</el-menu-item>
      <el-menu-item index="/news">服务介绍</el-menu-item>
      <el-menu-item index="/case">联系我们</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {}
</script>

<style scoped></style>
